const SINGLE_METRIC_TEMPLATE_PATH = "/app/components/single-metric/cell-templates/";
/*
 * @param {obj} config
 * @returns {obj} row configuration object
 */
function Row(config) {
    this.field = config.field || "TotalVisits";
    this.displayName = config.displayName || "Total Visits";
    this.cellTemplate = SINGLE_METRIC_TEMPLATE_PATH + (config.cellTemplate || "default") + ".html";
    this.headerTemplate =
        config.headerTemplate === "none"
            ? false
            : SINGLE_METRIC_TEMPLATE_PATH + (config.headerTemplate || "default-header") + ".html";
    this.format = config.format || "";
    this.titleFormat = config.titleFormat || "";
    this.rowClass = config.rowClass || null;
    this.isBeta = config.isBeta;
    this.ppt = config.ppt;
    this.tooltip = config.tooltip;
    this.filter = config.filter;
    this.displayNoData = config.displayNoData;
    this.invertChangeColor = config.invertChangeColor;
}

class SingleMetricService {
    row(config) {
        return new Row(config);
    }
}

export default new SingleMetricService();
